import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc244342"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main tw-overflow-x-hidden" }
const _hoisted_2 = { class: "xl:tw-px-[60px] tw-py-[55px] tw-px-[10px] tw-bg-white" }
const _hoisted_3 = { class: "title-inner tw-flex tw-items-center" }
const _hoisted_4 = { class: "tw-leading-[100%] tw-text-[#211F58] tw-font-semibold tw-ml-[25px]" }
const _hoisted_5 = {
  id: "clickbox-manage-role",
  class: "tw-py-[40px] xl:tw-py-[55px] xl:tw-px-[60px] tw-px-[10px] roles-container tw-flex tw-gap-[60px]"
}
const _hoisted_6 = { class: "content tw-flex-1 tw-max-w-[1182px]" }
const _hoisted_7 = { class: "table-content" }
const _hoisted_8 = { class: "manageRole-table" }
const _hoisted_9 = { class: "table-header tw-flex tw-flex-col md:tw-flex-row tw-mb-[26px] md:tw-items-center tw-justify-start md:tw-justify-between" }
const _hoisted_10 = { class: "tw-text-[#211F58] tw-text-[18px] tw-leading-[100%] tw-font-semibold tw-flex-1" }
const _hoisted_11 = { class: "manage-role tw-bg-white" }
const _hoisted_12 = { class: "manage-role-title tw-pt-5 tw-pb-5 tw-pl-10 tw-pr-10" }
const _hoisted_13 = { class: "header-title" }
const _hoisted_14 = { class: "tw-pt-[20px] tw-pb-[40px]" }
const _hoisted_15 = ["for"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tw-ml-1 tw-text-[#F7553C]" }, "*", -1))
const _hoisted_17 = { class: "dropdown" }
const _hoisted_18 = {
  key: 1,
  class: "tw-min-h-[58px] custom-global-skeleton tw-rounded-md tw-px-[20px] tw-py-[11px] tw-flex tw-items-center tw-justify-end tw-border tw-border-[#EFF0F1] tw-border-solid"
}
const _hoisted_19 = ["for"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tw-ml-1 tw-text-[#F7553C]" }, "*", -1))
const _hoisted_21 = { class: "users-table tw-mt-[40px]" }
const _hoisted_22 = { class: "table-header tw-flex tw-flex-col md:tw-flex-row md:tw-items-center tw-justify-start md:tw-justify-between tw-mb-[15px]" }
const _hoisted_23 = { class: "tw-text-[#211F58] tw-text-[18px] tw-leading-[100%] tw-font-semibold tw-flex-1 tw-mb-[15px] md:tw-mb-[0px]" }
const _hoisted_24 = { class: "group-button tw-flex tw-items-center tw-justify-between" }
const _hoisted_25 = { class: "tw-flex tw-justify-end tw-mt-[40px]" }
const _hoisted_26 = { class: "tw-max-w-[241px] xl:tw-min-w-[241px] tw-order-[1] md:tw-order-[2] tw-w-[100%] tw-flex tw-justify-center tw-rounded-br-md tw-rounded-bl-md tw-h-[fit-content] actionsWrapper" }

import AppBarLayout from "@/components/layouts/appBarLayout.vue";
import IconButton from "@/components/common/iconButton.vue";
import {
  onBeforeMount,
  ref,
  reactive,
  Ref,
  onMounted,
  computed,
  watch,
} from "vue";

import store from "@/store";
import ActionButton, { Action } from "@/components/common/actionButton.vue";
import backgroundComponent from "@/components/common/backgroundComponent.vue";
import ActivePathWrapper from "@/components/common/activePathWrapper.vue";
import ButtonBulkActions from "@/components/common/setting/buttonBulkActions.vue";
import ManageRoleTable from "@/components/common/setting/manageRoleTable.vue";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import { compareObjects, getComponentUiText } from "@/utils/utilities";
import BaseInput from "@/components/common/form/baseInput.vue";
import BaseSubmit from "@/components/common/form/baseSubmit.vue";
import Tooltip from "@/components/common/tooltip.vue";
import CustomBDropDown from "@/components/common/customBDropDown.vue";
import CustomBDropDownItem from "@/components/common/customBDropDownItem.vue";
import BrandPattern4 from "@/components/prospect/brandPattern/brandPattern4.vue";
import VRuntimeTemplate from "vue3-runtime-template";
import CustomDropDownItem from "@/components/common/customDropDownItem.vue";
import AddUserRoleModal from "@/components/team/roles/addUserRoleModal.vue";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import ManageUserModal from "@/components/orgManagement/manageUserModal.vue";
import router from "@/router";
import { cloneDeep } from "lodash";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import {
  deleteMembersOfRole,
  fetchOrgRolesTypes,
  putOrgRole,
} from "@/services/org";
import get from "lodash/get";
import { useRoute } from "vue-router";
import { getOrgRoleById, getMemberOfRoles } from "@/services/org/index";
import { IOrgRoleMember } from "@/interfaces/orgInterfaces";
import { IOrgMember, IOrgRole } from "@/interfaces/org/role";
import { MODAL_NAME, routers, successStatusCodes } from "@/utils/constants";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import uniqBy from "lodash/uniqBy";
import AddIcon from "@/components/svgs/addIcon.vue";
import DeleteIcon from "@/components/svgs/deleteIcon.vue";
import { showErrorAPI } from "@/services/apiRoutes";
import { Org } from "@/services/apiRoutes/routes";
import ArrowIcon from "@/components/svgs/arrowIcon.vue";
import { IModalMessage } from "@/interfaces/common/common";
import { deleteRole } from "@/services/org";
import CustomSwitchCheckbox from "@/components/common/customSwitchCheckbox.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'manageRole',
  setup(__props) {

const role = ref({} as IOrgRole);
const members = ref([] as IOrgMember[]);
const showTooltip = ref("");
const showBulkActions = ref(false);
let showModalDeleteUsers = ref(false);
let showModalDeleteUser = ref(false);
const showLoadingModalDeleteUser = ref(false);
let showModalDeleteRole = ref(false);
let onUpdateAction = ref(false);
let reFreshTable = ref(false);
const showModalAddUser: Ref<boolean> = ref(false);
const privilegeLevelOptions: Ref<IDropDownData[]> = ref([]);
const isSkeleton = ref(true);
const userSelectedCount = ref(0);

let userSelected = [] as IOrgMember[];
let idDeletingUser = null;
const originalData: IOrgRole = {
  roleName: "",
  permissionLevel: "",
  orgId: "",
  orgNameCode: "",
  orgNameShort: "",
  permissionLevelId: "",
  roleDescription: "",
  roleId: "0",
  roleRequiresMFA: false,
  roleTypeId: "",
  roleTypeName: "",
};
let form = reactive(cloneDeep(originalData));
const rules = {
  roleName: {
    required: helpers.withMessage(
      () =>
        getComponentUiText("app-common-form-field-required-1", false, {
          field: getComponentUiText(
            "app-settings-team-roles-manage-role-form-label-role-tile-1",
          ),
        }),
      required,
    ),
  },
  permissionLevel: {},
};

const isLoading: Ref<boolean> = ref(false);
let v$ = useVuelidate(rules, form, { $scope: false });
const route = useRoute();

const onSubmit = async () => {
  const result = await v$.value.$validate();

  if (result && !isLoading.value) await updateRoleById();
  isLoading.value = false;
};
const roleId = ref(route.params["roleId"] as string);
onBeforeMount(() => {
  initialData();

  store.dispatch("Navigation/setActiveHierarchy", [
    getComponentUiText("app-menu-submenu-settings-1"), //"Settings",
    getComponentUiText("app-menu-submenu-settings-team-1"), //"Team",
    getComponentUiText("app-menu-submenu-settings-team-roles-1"), //"Roles",
    getComponentUiText("app-settings-team-roles-more-modal-manage-role-1"), //"Manage Role"
  ]);
});

const currentOrg = computed(() => store.state.Org.currentOrg);

watch(
  () => currentOrg.value,
  (newValue, oldValue) => {
    if (newValue.id && oldValue.id && newValue.id !== oldValue.id) {
      router.replace(routers.settingTeamRoles);
    }
  },
  { deep: true },
);

const handleShowModalAddUser = () => {
  showModalAddUser.value = true;
};

const actions: Action[] = [
  {
    icon: AddIcon,
    title: "app-settings-team-roles-manage-role-right-actions-add-user-1",
    titleClass: "tw-w-[100%] tw-w-[151px]",
    onClick: () => handleShowModalAddUser(),
  },
  {
    icon: DeleteIcon,
    title: "app-settings-team-roles-more-modal-delete-role-1",
    titleClass: "tw-w-[100%] tw-w-[151px] title",
    class: "disableed",
    onClick: () => {
      showModalDeleteRole.value = true;
    },
  },
];

const usersTableFields = [
  {
    key: "info",
    label: getComponentUiText("app-component-custom-table-header-name-1"),
    thClass: ["header-user"],
  },
  {
    key: "homeOrgNameShort",
    label: getComponentUiText("app-settings-team-members-table-header-org-1"),
    tdClass: "tw-w-3/4",
    thClass: ["header-organization"],
  },
  { key: "actions", label: "", tdClass: ["td-actions"] },
];

let privilegeLevelSelect: Ref<IDropDownData[]> = ref([]);

const initialData = async () => {
  if (route.params && route.params["roleId"]) {
    await Promise.all([
      fetchRoleById(route.params["roleId"] as string),
      fetchMemberByRoleId(route.params["roleId"] as string),
    ]);
  }

  if (role.value && role.value.roleId) bindingDataToForm();
};

const fetchRoleById = async (id: string) => {
  try {
    const res = await getOrgRoleById(id);
    role.value = get(res, "data.data", {} as IOrgRole);
  } catch (error: any) {
    role.value = {} as IOrgRole;
    if (error && error.data) {
      showErrorAPI(error, Org.getOrgRoleById);
    }
  }
};

const updateRoleById = async () => {
  isLoading.value = true;
  const payload = {
    roleName: form.roleName,
    roleTypeId: form.roleTypeId,
    requireMFA: form.roleRequiresMFA,
  };

  try {
    const res = await putOrgRole(role.value.roleId, payload);
    await new Promise((resolve) => setTimeout(resolve, 550));

    if (res && res.status === successStatusCodes.OK) {
      showToastMessage(
        true,
        getComponentUiText(
          "app-settings-team-roles-manage-role-toast-message-update-role-success-1",
        ),
      );
    }
  } catch (error: any) {
    showErrorAPI(error, Org.getOrgRoleById);
  }

  return true;
};

const showToastMessage = (isSuccess: boolean, message: string) => {
  const emitData: IToastMessage = {
    variant: isSuccess ? ToastVariant.SUCCESS : ToastVariant.ERROR,
    message: message,
  };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

const fetchMemberByRoleId = async (roleId) => {
  try {
    const res = await getMemberOfRoles(roleId);

    members.value = get(res, "data.data.members", []);
    members.value = members.value.map((member) => {
      return { ...member, info: member, userId: member.userId };
    });
    isSkeleton.value = false;
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.getMembersOfRole);
    }
  }
};

const bindingDataToForm = () => {
  for (const key in form) {
    if (Object.prototype.hasOwnProperty.call(role.value, key)) {
      form[key] = role.value[key];
    }
  }
};

const handleSelectRole = (role: IDropDownData) => {
  privilegeLevelSelect.value = [role];
  form.roleTypeId = role.id as string;
};

const handleSelectUser = (members: IOrgRoleMember[], isSelectAll = false) => {
  if (members.length < 1) {
    isShowMoreActions.value = false;
  }
  if (isSelectAll) {
    userSelected = Object.assign([], members);
  } else {
    members.forEach((user) => {
      const index = userSelected.findIndex(
        (item) => item.userId === user.userId,
      );
      if (index !== -1) userSelected.splice(index, 1);
      else userSelected.push(user);
    });
  }

  if (userSelected.length >= 1) showBulkActions.value = true;
  else showBulkActions.value = false;
  userSelectedCount.value = userSelected.length;
};

const handleAddUserToRole = ($event) => {
  if ($event && $event.users && $event.users.length)
    members.value = uniqBy(
      members.value.concat(
        $event.users.map((member) => {
          return { ...member, info: member };
        }),
      ),
      "userId",
    );
};

const handleMultipleSelect = () => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
    properties: {
      title: getComponentUiText(
        "app-settings-team-roles-manage-role-bulk-actions-modal-remove-user-1",
      ),
      description: getComponentUiText(
        "app-settings-team-roles-manage-role-bulk-actions-modal-remove-user-description-1",
      ),
      show: true,
      list: userSelected.map((user) => user?.firstName + " " + user?.lastName),
      buttonRed: true,
      updateDataFunction: onDeleteUsers,
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const onDeleteUsers = async () => {
  showModalDeleteUsers.value = false;
  try {
    const payload = {
      members: userSelected.map((user) => user.userId),
    };
    const res = await deleteMembersOfRole(role.value.roleId, payload);
    if (res && res.data) {
      showToastMessage(
        true,
        getComponentUiText(
          "app-settings-team-roles-manage-role-toast-message-removed-user-success-1",
        ),
      );
      const reMainUser = members.value.filter(
        (user) => !userSelected.includes(user),
      );
      members.value = reMainUser;
      reFreshTable.value = true;
      updateAction();
      showBulkActions.value = false;
      setTimeout(() => {
        reFreshTable.value = false;
      }, 100);
    }
  } catch (error: any) {
    if (error && error.data) {
      const message =
        error.data.error && error.data.error.type
          ? error.data.error.message
          : error.data.message;
      showToastMessage(false, message);
    }
  }
};

const deleteUser = (item) => {
  idDeletingUser = item.userId;
  showModalDeleteUser.value = true;
};

const onDeleteUser = async () => {
  showLoadingModalDeleteUser.value = true;

  try {
    const payload = {
      members: [idDeletingUser],
    };
    const res = await deleteMembersOfRole(role.value.roleId, payload);
    if (res && res.data) {
      showToastMessage(
        true,
        getComponentUiText(
          "app-settings-team-roles-manage-role-toast-message-removed-user-success-1",
        ),
      );
      members.value = members.value.filter(
        (user) => user.userId !== idDeletingUser,
      );
      reFreshTable.value = true;
      userSelected = userSelected.filter(
        (user) => user.userId !== idDeletingUser,
      );
      updateAction();
      setTimeout(() => {
        reFreshTable.value = false;
        idDeletingUser = null;
      }, 100);
    }
  } catch (error: any) {
    if (error && error.data) {
      const message =
        error.data.error && error.data.error.type
          ? error.data.error.message
          : error.data.message;
      showToastMessage(false, message);
    }
  } finally {
    showModalDeleteUser.value = false;
    showLoadingModalDeleteUser.value = false;
  }
};

const updateAction = () => {
  if (members.value.length === 0) {
    actions[1].class = "delete";
    onUpdateAction.value = true;
  }
};

const onDeleteRole = async () => {
  showModalDeleteRole.value = false;
  try {
    const res = await deleteRole(form.roleId);
    if (res && res.data) {
      store.dispatch("Org/setOrgRoles", res.data.data);
      const emitData: IToastMessage = {
        variant: ToastVariant.SUCCESS,
        message: getComponentUiText(
          "app-settings-team-roles-manage-role-toast-message-delete-role-success-1",
        ),
      };
      EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
      router.push({ path: "/settings/team/roles" });
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.deleteRole);
    }
  }
};

const goBack = () => {
  router.push({ path: "/settings/team/roles", replace: true });
  store.dispatch("Navigation/setActiveHierarchy", [
    getComponentUiText("app-menu-submenu-settings-1"), //"Settings",
    getComponentUiText("app-menu-submenu-settings-team-1"), //"Team",
    getComponentUiText("app-menu-submenu-settings-team-roles-1"), //"Roles",
  ]);
};

const isChangeData = () => {
  return !compareObjects(form, originalData);
};

watch(
  () => [role.value, privilegeLevelOptions.value],
  ([firstVal, secondVal]) => {
    const role = firstVal as IOrgRole;
    const privilegeLevelOptions: any = secondVal;
    if (role && role.roleId && privilegeLevelOptions.length) {
      privilegeLevelSelect.value = [
        {
          id: role.roleTypeId,
          name:
            privilegeLevelOptions.find(
              (item) => item.roleTypeId === role.roleTypeId,
            )?.roleTypeName || "",
        },
      ];
    }
  },
);

onMounted(async () => {
  const responseData = await fetchOrgRolesTypes();
  const privilegeLevelOptionsResponse = get(responseData, "data.data", []);
  privilegeLevelOptions.value = privilegeLevelOptionsResponse.map((item) => {
    return { ...item, id: item.roleTypeId, name: item.roleTypeName };
  });

  EventEmitter.on(EmitterEvents.ROLE_CREATED, (value: any) => {
    showTooltip.value = value.roleTitle;
  });
});
const isShowMoreActions = ref(false);
const handleShowBulkAction = () => {
  isShowMoreActions.value = !isShowMoreActions.value;
  if (userSelected.length < 1) {
    isShowMoreActions.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_BForm = _resolveComponent("BForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppBarLayout, null, {
      default: _withCtx(({ activeHierarchy }) => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(BrandPattern4, { page: "APPBARLAYOUT" }),
          _createVNode(backgroundComponent),
          _createVNode(ActivePathWrapper, {
            "active-hierarchy": activeHierarchy,
            navigate: ['', '', '/settings/team/roles', '']
          }, null, 8, ["active-hierarchy"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(IconButton, {
                src: "/img/back_icon.svg",
                class: "!tw-bg-[#0345BD] !tw-w-[22px] !tw-min-w-[22px] !tw-h-[22px] !tw-p-[0px] !tw-pr-[2px]",
                onClick: goBack
              }),
              _createElementVNode("span", _hoisted_4, _toDisplayString(role.value.roleName), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_BForm, {
                  onSubmit: _withModifiers(onSubmit, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(getComponentUiText)(
                          "app-settings-team-roles-manage-role-subtitle-1",
                        )), 1)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(getComponentUiText)(
                          "app-settings-team-roles-manage-role-heading-role-details-1",
                        )), 1)
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(BaseInput, {
                            modelValue: _unref(form).roleName,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).roleName) = $event)),
                            validation: _unref(v$).roleName,
                            "validate-on-blur": true,
                            label: 
                          _unref(getComponentUiText)(
                            'app-settings-team-roles-manage-role-form-label-role-tile-1',
                          )
                        ,
                            "is-skeleton": isSkeleton.value,
                            class: "!tw-pl-10 !tw-pr-10",
                            "data-cy-id": "manage-role-role-name-input"
                          }, null, 8, ["modelValue", "validation", "label", "is-skeleton"]),
                          _createVNode(_component_b_row, { class: "tw-mt-[20px] tw-pl-10 tw-pr-10" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_b_col, { sm: "5" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("label", {
                                    class: "label-form tw-mb-1 tw-text-[14px] tw-font-[500]",
                                    for: `inputItem.valueField`
                                  }, [
                                    _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
                                "app-settings-team-roles-manage-role-form-label-privilege-level-1",
                              )) + " ", 1),
                                    _hoisted_16
                                  ], 8, _hoisted_15)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_b_col, { sm: "7" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_17, [
                                    (!isSkeleton.value)
                                      ? (_openBlock(), _createBlock(CustomBDropDown, {
                                          key: 0,
                                          id: "dropdownIcon",
                                          "data-cy-id": "manage-role-privilege-level-dropdown",
                                          type: 'single',
                                          data: _unref(privilegeLevelSelect),
                                          "class-name": "gray-dropdown-container tw-text-normal tw-min-h-[58px]"
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(privilegeLevelOptions.value, (option) => {
                                              return (_openBlock(), _createBlock(CustomBDropDownItem, {
                                                key: option.id,
                                                data: option,
                                                "data-cy-id": `manage-role-privilege-level-dropdown-item-${option.id}`,
                                                "class-name": 'normal-dropdown-container',
                                                onClick: ($event: any) => (handleSelectRole(option))
                                              }, null, 8, ["data", "data-cy-id", "onClick"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["data"]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                          _createVNode(ArrowIcon, {
                                            class: "bottom-arrow",
                                            width: 6.661,
                                            height: 10
                                          })
                                        ]))
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_b_row, { class: "tw-mt-[20px] tw-pl-10 tw-pr-10" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_b_col, { sm: "5" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("label", {
                                    class: "label-form tw-mb-1 tw-text-[14px] tw-font-[500]",
                                    for: `inputItem.valueField`
                                  }, [
                                    _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
                                "app-settings-team-roles-manage-role-form-label-mfa-required-1",
                              )) + " ", 1),
                                    _hoisted_20
                                  ], 8, _hoisted_19)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_b_col, { sm: "7 " }, {
                                default: _withCtx(() => [
                                  _createVNode(CustomSwitchCheckbox, {
                                    modelValue: _unref(form).roleRequiresMFA,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).roleRequiresMFA) = $event)),
                                    checked: _unref(form).roleRequiresMFA,
                                    class: "tw-mb-0",
                                    "class-name": "grey-slider",
                                    "onUpdate:checkbox": _cache[2] || (_cache[2] = 
                              (value) => (_unref(form).roleRequiresMFA = value)
                            )
                                  }, null, 8, ["modelValue", "checked"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(getComponentUiText)(
                          "app-settings-team-roles-manage-role-users-subtitle-1",
                        )), 1),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", { onClick: handleShowBulkAction }, [
                            _createVNode(ButtonBulkActions, {
                              active: showBulkActions.value,
                              class: _normalizeClass(`!tw-border tw-border-1 !tw-border-solid !tw-border-[#EFF0F1]`),
                              "id-popover": `popover-btn-bulk-action-manage-role`,
                              "show-more-actions": isShowMoreActions.value,
                              "show-acction-click": true,
                              "selected-number": userSelectedCount.value
                            }, {
                              default: _withCtx(() => [
                                _createVNode(CustomDropDownItem, {
                                  style: 'danger',
                                  "data-cy": "manage-role-remove-user-button",
                                  "id-text": 'app-assessment-modal-remove-attachment-button-text-1',
                                  onClick: handleMultipleSelect
                                })
                              ]),
                              _: 1
                            }, 8, ["active", "show-more-actions", "selected-number"])
                          ]),
                          _createVNode(IconButton, {
                            src: "/img/plus_icon.svg",
                            onClick: handleShowModalAddUser
                          })
                        ])
                      ]),
                      _createVNode(ManageRoleTable, {
                        "table-data": members.value,
                        "table-fields": usersTableFields,
                        "re-fresh": _unref(reFreshTable),
                        "is-skeleton": isSkeleton.value,
                        "onSelect:one_row": _cache[3] || (_cache[3] = ($event: any) => (handleSelectUser($event, false))),
                        "onSelect:all_row": _cache[4] || (_cache[4] = ($event: any) => (handleSelectUser($event, true))),
                        "onDelete:one_row": deleteUser
                      }, null, 8, ["table-data", "re-fresh", "is-skeleton"])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(BaseSubmit, {
                        title: 
                      _unref(getComponentUiText)('app-common-save-change-button-1')
                    ,
                        "data-cy-id": "manage-role-save-button",
                        validation: _unref(v$),
                        "is-loading": isLoading.value,
                        "is-change-data": isChangeData(),
                        class: _normalizeClass(['tw-w-[fit-content]'])
                      }, null, 8, ["title", "validation", "is-loading", "is-change-data"])
                    ])
                  ]),
                  _: 1
                }, 8, ["onSubmit"])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createVNode(ActionButton, {
                "profile-actions": actions,
                member: members.value,
                length: members.value.length > 0 ? true : false,
                disable: isSkeleton.value,
                "on-update-action": _unref(onUpdateAction)
              }, null, 8, ["member", "length", "disable", "on-update-action"])
            ])
          ]),
          _createVNode(ManageUserModal, {
            show: _unref(showModalDeleteUsers),
            header: true,
            "red-btn": true,
            "header-title": "app-settings-team-members-profile-modal-delete-action-warning-1",
            "contain-title": "app-settings-team-roles-manage-role-remove-users-action-title-1",
            "contain-sub-title": "app-settings-team-roles-manage-role-remove-users-action-helper-a-1",
            "action-title": "app-settings-team-roles-manage-role-remove-users-action-title-1",
            "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => (_isRef(showModalDeleteUsers) //@ts-ignore
 ? showModalDeleteUsers.value = $event : showModalDeleteUsers = $event)),
            "onUpdate:actionHandle": onDeleteUsers
          }, null, 8, ["show"]),
          _createVNode(ManageUserModal, {
            show: _unref(showModalDeleteUser),
            header: true,
            "red-btn": true,
            "required-show-loading": true,
            "is-loading-button": showLoadingModalDeleteUser.value,
            "header-title": "app-settings-team-members-profile-modal-delete-action-warning-1",
            "contain-title": "app-settings-team-roles-manage-role-remove-user-action-title-1",
            "contain-sub-title": "app-settings-team-roles-manage-role-remove-user-action-helper-a-1",
            "action-title": "app-settings-team-roles-manage-role-remove-user-action-title-1",
            "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => (_isRef(showModalDeleteUser) //@ts-ignore
 ? showModalDeleteUser.value = $event : showModalDeleteUser = $event)),
            "onUpdate:actionHandle": onDeleteUser
          }, null, 8, ["show", "is-loading-button"]),
          _createVNode(ManageUserModal, {
            show: _unref(showModalDeleteRole),
            header: true,
            "red-btn": true,
            "header-title": "app-settings-team-members-profile-modal-delete-action-warning-1",
            "contain-title": "app-settings-team-roles-manage-role-delete-role-action-title-1",
            "contain-sub-title": "app-settings-team-roles-manage-role-delete-role-action-helper-a-1",
            "action-title": "app-settings-team-roles-manage-role-delete-role-action-title-1",
            "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => (_isRef(showModalDeleteRole) //@ts-ignore
 ? showModalDeleteRole.value = $event : showModalDeleteRole = $event)),
            "onUpdate:actionHandle": onDeleteRole
          }, null, 8, ["show"])
        ])
      ]),
      _: 1
    }),
    _createVNode(Tooltip, {
      id: "demo-tt",
      variant: "success",
      show: !!showTooltip.value,
      onClose: _cache[8] || (_cache[8] = ($event: any) => (showTooltip.value = ''))
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", null, [
          _createVNode(_unref(VRuntimeTemplate), {
            template: 
          _unref(getComponentUiText)(
            'app-settings-team-roles-manage-role-toast-message-1',
            false,
            {
              roleTitle: `<span class='tw-font-semibold'>${showTooltip.value}</span>`,
            },
          )
        
          }, null, 8, ["template"])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(AddUserRoleModal, {
      show: showModalAddUser.value,
      "role-id": roleId.value,
      "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => (showModalAddUser.value = $event)),
      "onAdd:userToRole": _cache[10] || (_cache[10] = ($event: any) => (handleAddUserToRole($event)))
    }, null, 8, ["show", "role-id"])
  ], 64))
}
}

})